<template>
	<div class="b-productCard" itemscope itemtype="http://schema.org/Product" :id="product.areaId"
	     :class="{'b-productCard_preorder': !product.price.can_buy || product.catalogQuantity == 0}"
	>
		<a :href="product.detailPageUrl" class="b-productCard__top" :title="loc.CITRUS_VUE_PRODUCT_ITEM_MORE + product.name">
			<span class="b-productCard__label">
				<div class="b-label b-label_small" v-for="sticker in product.stickers"
				     :class="sticker.code ? sticker.code : ''">
				<span v-html="sticker.name"></span>
			</div>
			</span>
			<picture class="b-productCard__imgWrap">
				<source v-if="product.picture.src && product.picture.hasOwnProperty('webp')" :srcset="product.picture.webp"
				        type="image/webp">
				<img v-if="product.picture.src" class="b-productCard__img" :src="NO_IMAGE" :data-src="product.picture.src" :alt="product.name"/>
			</picture>
		</a>
		<div class="b-productCard__bottom">
			<div class="b-productCard__content">
				<div class="b-productCard__info">
					<div class="b-productCard__line b-productCard__line_label">
						<span class="b-label b-label_note" v-if="product.section" v-html="product.section.name"></span>
						<span class="b-productCard__note" v-if="product.price.can_buy && product.catalogQuantity > 0"
						      v-html="loc.CITRUS_VUE_PRODUCT_ITEM_AVAILABLE + ' ' + product.catalogQuantity"></span>
						<span class="b-productCard__note" v-else v-html="loc.CITRUS_VUE_PRODUCT_ITEM_AVAILABLE_ON_ORDER"></span>
					</div>
					<div class="b-productCard__line">
						<span class="b-productCard__note" v-if="product.article"
						      v-html="loc.CITRUS_VUE_PRODUCT_ITEM_ARTICLE + ' ' + product.article"></span>
						<span class="b-productCard__note" v-if="product.xmlId" v-html="loc.CITRUS_VUE_PRODUCT_ITEM_XML_ID + ' ' + product.xmlId"></span>
					</div>
				</div>
				<a :href="product.detailPageUrl" class="b-productCard__title" itemprop="name" v-html="product.name"></a>
			</div>
			<citrus-product-basket-button-with-quantity
				:metric-goal="metricGoal"
				:storage-type="storage"
				:product-id="product.id"
				:detail-url="product.detailPageUrl"
				:price="product.price"
				:measure="product.measure"
				:basket-url="basketUrl"
				:button-class="buttonClass"
				:quantity-class="quantityClass"
				:price-class="priceClass"
				:show-price="true"
				:max-quantity="product.catalogQuantity"
				class="b-productCard__line b-productCard__line_price"
			></citrus-product-basket-button-with-quantity>
		</div>

	</div>
</template>
<script>
import {Vue} from "ui.vue";

export default {
	name: "ProductItem",
	props: {
		product: {
			areaId: "",
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			detailPageUrl: {
				type: String,
				default: ""
			},
			picture: {
				type: Object,
				default: function () {
					return {
						src: "",
						width: 0,
						height: 0,
					}
				}
			},
			price: {
				price: {
					type: Number,
					default: 0
				},
				full: {
					type: Number,
					default: 0
				},
				in_basket: {
					type: Boolean,
					default: false
				},
			},
			measure: {
				type: Object,
				default: function () {
					return {
						id: 0,
						name: "",
						value: "",
						ratio: "",
					}
				}
			},
			bullets: {
				type: Array,
				default: []
			}
		},
		buttonClass: {
			type: String,
			default: 'b-basketBtn_productCard'
		},
		quantityClass: {
			type: String,
			default: 'b-counter_productCard'
		},
		priceClass: {
			type: String,
			default: 'b-price_productCard'
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		}
	},
	data: function () {
		return {
			storage: 'vuex',
			loading: false,
			NO_IMAGE: window.NO_IMAGE
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_ITEM_");
		}
	}
}
</script>